
/**
 * Copyright (C) 2021, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: HRBaseGameState.ts ,v 1.0 Exp $
 * Date Author Changes
 * April 20, 2021 Shruti Agrawal Created
 *
 */
namespace Reels {
    import Symbol = Symbols.Symbol;
    import BSReelPaddingConfig = Reels.BSReelPaddingConfig;
    import ReelSpinPhaseClientPadding = Reels.ReelSpinPhaseClientPadding;
    import AdpPhaserGame = Game.AdpPhaserGame;
    import ReelSoundPhase = Reels.ReelSoundPhase;
    
    export class BSReel extends Reel {
        constructor(game: AdpPhaserGame, availableSymbols: Symbol[], id: number, visibleSymbolCount: number, x: number, y: number, symbolWidth: number, symbolHeight: number) {
            super(game, availableSymbols, id, visibleSymbolCount, x, y, symbolWidth, symbolHeight);
        }
        
        protected createAnimation():void{
            this._animation = this.game.componentFactory.createReelAnimation(this);
            this._animation.data = this.game.componentFactory.createReelAnimationData(this,this.game);
            this._animation.setInitPhaseId(ReelAnimationPhaseId.REEL_SMOOTH_PHASE);
            this._animation.registerAnimationPhase(new ReelSmoothPhase(this.game,ReelAnimationPhaseId.REEL_SMOOTH_PHASE,ReelAnimationPhaseId.REEL_BLUR_PHASE));
            const blurPhase = new ReelBlurPhase(this.game,ReelAnimationPhaseId.REEL_BLUR_PHASE,ReelAnimationPhaseId.REEL_SPIN_PHASE);
            this._animation.registerAnimationPhase(blurPhase);
            let reelConfig: BSReelPaddingConfig = new Reels.BSReelPaddingConfig(this.game, this.id);
            this._animation.registerAnimationPhase(new ReelSpinPhaseClientPadding(this.game, ReelAnimationPhaseId.REEL_SPIN_PHASE, ReelAnimationPhaseId.REEL_SOUND_PHASE, reelConfig));
            this._animation.registerAnimationPhase(new ReelSoundPhase(this.game,ReelAnimationPhaseId.REEL_SOUND_PHASE,ReelAnimationPhaseId.REEL_TEASER_PHASE));
            let glowTriggers = [new ReelGlowTrigger(ReelAnimationPhaseId.REEL_GLOW_PHASE), new ReelAnimationTrigger(ReelAnimationPhaseId.REEL_SWINGOFF_PHASE)];
            this._animation.registerAnimationPhase(new ReelTeaserPhase(this.game,ReelAnimationPhaseId.REEL_TEASER_PHASE,glowTriggers,));
            this._animation.registerAnimationPhase(new BSTiGaReelSwingOffPhase(this.game,ReelAnimationPhaseId.REEL_SWINGOFF_PHASE,ReelAnimationPhaseId.REEL_CRISP_PHASE));
            this._animation.registerAnimationPhase(new ReelCrispPhase(this.game,ReelAnimationPhaseId.REEL_CRISP_PHASE,ReelAnimationPhaseId.REEL_CLEAR_FILTER_PHASE));
            this._animation.registerAnimationPhase(new ReelRemoveBlurPhase(this.game,ReelAnimationPhaseId.REEL_CLEAR_FILTER_PHASE,ReelAnimationPhaseId.REEL_CLEAR_PHASE,blurPhase));
            this._animation.registerAnimationPhase(new ReelGlowPhase(this.game,ReelAnimationPhaseId.REEL_GLOW_PHASE,ReelAnimationPhaseId.REEL_SWINGOFF_PHASE));
            this._animation.registerAnimationPhase(new ReelSpinClearPhase(this.game,ReelAnimationPhaseId.REEL_CLEAR_PHASE));
        }
    }
}
